export default "__VITE_ASSET__CCXVceVV__"